import {Controller} from "stimulus"
import $ from 'jquery';
import bootbox from 'bootbox';
import {checkSessionVar, setSessionVar} from "./sessionStorage_controller";
import toastr from "toastr";

let calc_size = (bytes) => {
    let kb = parseFloat(Math.round((bytes / 1024) * 100) / 100).toFixed(2);
    let mb = parseFloat(Math.round((kb / 1024) * 100) / 100).toFixed(2);
    let gb = parseFloat(Math.round((mb / 1024) * 100) / 100).toFixed(2);

    if(kb > 1024){
        if(mb > 1024){
            return `${gb} Gb`
        }else{
            return `${mb} Mb`
        }
    }else{
        return `${kb} Kb`
    }
}


export default class extends Controller {

    connect() {

    }

    previewImg(e){
        let archivos = e.target.files;
        let preview = $('#'+e.target.dataset.preview);
        preview[0].src = URL.createObjectURL(archivos[0]);
        document.getElementById('file_cancel_btn').classList.remove('hide');

        if(e.target.dataset.hasOwnProperty('getdata')){
           if(e.target.dataset.getdata === "true"){
              let name = document.getElementById(e.target.dataset.name);
              let ext = document.getElementById(e.target.dataset.ext);
              let size = document.getElementById(e.target.dataset.size);
              let mime = document.getElementById(e.target.dataset.mime);
              let dimensiones = document.getElementById(e.target.dataset.dimensiones);

              let aux = archivos[0].name
               aux = aux.split('.');
              name.value = aux[0];
              ext.value = aux[1];
              size.value = archivos[0].size
              mime.value = archivos[0].type
               dimensiones.value = `${preview[0].naturalWidth} x ${preview[0].naturalHeight}`

               ext.setAttribute('readonly',true);
               size.setAttribute('readonly',true);
               mime.setAttribute('readonly',true);
               dimensiones.setAttribute('readonly',true);


           }
        }
    }

    getSize(e){
        let calc = calc_size(e.target.dataset.bytes);
        document.getElementById(e.target.dataset.bytesPreview).innerText = calc;
    }

    remove_file(e){
        document.getElementById(e.target.dataset.inputfile).value = "";
        document.getElementById(e.target.dataset.preview).src = "data:image/png;base64,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";
        document.getElementById(e.target.dataset.cancel).classList.add('hide');

        let name = document.getElementById(e.target.dataset.name);
        let ext = document.getElementById(e.target.dataset.ext);
        let size = document.getElementById(e.target.dataset.size);
        let mime = document.getElementById(e.target.dataset.mime);
        let dimensiones = document.getElementById(e.target.dataset.dimensiones);


        name.value = '';
        ext.value = '';
        size.value = '';
        mime.value = '';
        dimensiones.value = '0 x 0';

        // ext.setAttribute('readonly',false);
        // size.setAttribute('readonly',false);
        // mime.setAttribute('readonly',false);

    }

    show(e){
        let support = 'all';
        if(e.target.dataset.hasOwnProperty('support')){
            support = e.target.dataset.support;
        }

        $.ajax({
            url: `${location.origin}/es/admin/media_galeries/reference/${e.target.dataset.itemcode}`,
            data: { support: support},
            type: 'GET',
            success: function(data){

                if(data.success){
                    let message = '';
                    if(data.type === 'image'){
                        message = `<img src='${data.file}'>`
                    }

                    if(data.type === 'video'){
                        message = `<video width = "500" height = "300" controls autoplay="autoplay">
                                     <source src = "${data.file}" type = "${data.mime}">
                                     Este navegador no soporta la etiqueta video.
                                  </video>`
                    }


                    bootbox.dialog({
                        title: `Media - ${data.code}`,
                        message: `<div class='bootbox-preview'>${message}</div>
                                  <div class='bootbox-info-preview'>
                                     <span><strong>Nombre:</strong> ${data.name}</span>
                                     <span><strong>Nombre original:</strong> ${data.original_name}</span>
                                     <span><strong>MIME/Type:</strong> ${data.mime}</span>
                                     <span><strong>Extensión:</strong> ${data.ext}</span>
                                     <span><strong>Tamaño del fichero:</strong> ${calc_size(data.size)}</span>
                                     <span><strong>Dimensiones:</strong> ${data.dimention}</span>
                                     <span><strong>Código de referencia:</strong> ${data.code}</span>
                                     <span><strong>Creado:</strong> ${data.create_at}</span>
                                  </div>  
                                    `
                        ,
                        className: 'preview'
                    })
                }else{
                    bootbox.alert(data.msg);
                }

            }

        })
    }

    showPublic(e){
        let support = 'all';
        if(e.target.dataset.hasOwnProperty('support')){
            support = e.target.dataset.support;
        }

        $.ajax({
            url: `${location.origin}/es/admin/media_galeries/reference/${e.target.dataset.itemcode}`,
            data: { support: support},
            type: 'GET',
            success: function(data){
                if(data.success){
                    let message = '';
                    if(data.type === 'image'){
                        message = `<img src='${data.file}'>`
                    }

                    if(data.type === 'video'){
                        message = `<video width = "500" height = "300" controls autoplay="autoplay">
                                     <source src = "${data.file}" type = "${data.mime}">
                                     Este navegador no soporta la etiqueta video.
                                  </video>`
                    }

                    bootbox.dialog({
                        title: ``,
                        message: `<div class='bootbox-preview-public'>${message}</div>`,
                        size: 'large',
                        className: 'preview'
                    })
                }else{
                    bootbox.alert(data.msg);
                }
            }
        })
    }

    download(e){
        location.href = `${location.origin}/es/admin/media_galeries/download/${e.target.dataset.itemcode}`
    }

    show_by_url(e) {
        bootbox.dialog({
            title: `Imagen`,
            size: 'xl',
            message: `
                    <div class='bootbox-preview'>
                        <img src="${e.target.dataset.url}" alt="Imagen">
                    </div>
                    `,
            className: 'preview'
        })
    }
}